<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
        <ion-title><HomeButton/> {{ tool.title }}</ion-title>


      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-slides>
        <ion-slide v-for="content in tool.content" v-bind:key="content.id">
          <span v-html="content"></span>
        </ion-slide>
      </ion-slides>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {IonPage, IonContent, IonToolbar, IonButtons, IonBackButton, IonSlides, IonSlide} from '@ionic/vue'
import {defineComponent} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import {useStore} from "@/store/store";
import {createEmptyTool, Tool, ToolUtils} from "@/store/state";
import HomeButton from "@/components/HomeButton.vue";
import MarkdownIt from "markdown-it"

export default defineComponent({
  components: {HomeButton, IonPage, IonContent, IonToolbar, IonButtons, IonBackButton, IonSlides, IonSlide},
  name: "Tool",
  watch: {
    realToolId: {
      handler(n: string, o: string) {
        console.log("watch handled", n);
        this.loadTool(n)
      },
      immediate: true
    }
  },

  methods: {
    loadTool(id: string | null) {

      if (id) {

        const filtered = this.store.state.tools.filter((t: Tool) => t.id === id)
        if (filtered.length) {

          this.tool = filtered.pop() ?? this.tool;
          this.tool = ToolUtils.translate(this.tool);
          const md = new MarkdownIt();
          for(let i=0; i<this.tool.content.length;i++){
            this.tool.content[i]= md.render(this.tool.content[i].replaceAll("\\n","\n"))
          }
          console.log(this.tool);
          //clone!
        }
      } else {

        this.tool = createEmptyTool();

      }
    }
  },
  setup(props) {

    const router = useRouter();
    const {t, locale} = useI18n()
    const store = useStore();

    //scheiss workaround, bis das routing richtig funktioniert
    const route = useRoute();
    const realToolId = route.params['toolId'];

    const tool: Tool = createEmptyTool();
    return {
      t,
      locale,
      router,
      store,
      tool,
      realToolId
    }
  }
});
</script>

<style scoped>

ion-slides {
  height: 100%;
}
</style>